import React, { useState, useEffect, useRef } from "react";
import { useUser } from "contexts/UserContext";
import CTTable from "./CTTable";
import CTSelectTable from "./CTSelectTable";
import CTButton from "./CTButton";
import CTEdit from "./CTEdit";

const CTMatchList = ({
  matchName,
  onSelectRow, // callback doble click
  onSelectRows, // callback selección múltiple
  maxHeight = 400,
  multiSelect = false,
}) => {
  const { matchCodes, matchCodeData, loadMatchCodeData } = useUser();
  const [data, setData] = useState([]);
  const [visibleFields, setVisibleFields] = useState([]);
  const [positionUp, setPositionUp] = useState(false);
  const containerRef = useRef(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [fieldKey, setFieldKey] = useState("");
  const [matchCode, setMatchCode] = useState(null);
  const searchRef = useRef(null);
  const field_key="key";
  const field_des="value";


  // --- Carga de datos y configuración ---
  useEffect(() => {
    const loadData = async () => {
      if (!matchName) return;

      const mc = matchCodes.find((m) => m.FICHA === matchName);
      if (!mc) return;

      setMatchCode(mc);
      //setFieldKey(mc.FIELD_KEY.trim());
      setFieldKey(field_key);

      const fields = mc.FIELDS?.filter((f) => f.VISIBLE) || [];
      setVisibleFields(fields);

      //if (!mc.FIELD_KEY.trim()) setFieldKey(fields[0]?.NAME);

      let rows = mc?.LSData
      if (!rows) {
        rows = await loadMatchCodeData(mc.FICHA);
      }
      
      setData(rows ?rows :[]);
    };

    loadData();
  }, [matchName, matchCodes, matchCodeData, loadMatchCodeData]);


  // --- Ajuste de posición del dropdown ---
  useEffect(() => {
    if (!containerRef.current) return;

    const rect = containerRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    setPositionUp(spaceBelow < maxHeight && spaceAbove > spaceBelow);
  }, [data, maxHeight]);

  if (!matchName || data.length === 0 || !matchCode) return null;

  const tipoPresent = matchCode.TIPO_PRESENTACIO;
  const hihafiltros = matchCode?.TIPO_FILTROS==="X" ? 1: 0 ;
  const getRowId = (row) => row.ID || row.IDX || row[fieldKey];

  // --- Handlers ---
  const onSelectRowTable = (row, rowid) => {
    setSelectedRowId(rowid);
    if (onSelectRow) onSelectRow(row,matchName);
  };

  const onDoubleRowTable = (row, rowid) => {
    if (onSelectRow) onSelectRow(row,matchName);
  };

  const onSelectionChange = (newData) => {
    const selected = newData.filter((r) => r.check);
    setSelectedRows(selected);
    if (onSelectRows) onSelectRows(selected);
    setSelectedRowId(selected[0] ? getRowId(selected[0]) : null);
  };

  const onDoubleClickMulti = (row) => {
    if (onSelectRow) onSelectRow(row,matchName);
  };

  // --- Render condicional para distintos tipos de tabla ---
  return (
    <div
      ref={containerRef}
      className="relative flex-1 "
      style={{ position: "relative" }}
      
    >
      <div
        className="absolute z-50 bg-white border border-gray-300 shadow-lg max-h-[350px]  overflow-hidden"
        style={{
          maxHeight: `${maxHeight}px`,
          marginTop: positionUp ? undefined : "0.25rem",
          marginBottom: positionUp ? "0.25rem" : undefined,
          bottom: positionUp ? "calc(100% - 2rem)" : undefined, // 👈 sube 10px para tapar un poco
          top: positionUp ? undefined : "calc(100% - 2rem)", // 👈 igual cuando va hacia abajo
          maxWidth: "1200px",
          minWidth: containerRef.current
            ? `${containerRef.current.offsetWidth}px`
            : "100%",
        }}
      >
      <div className="flex flex-col gap-2 w-max min-w-full p-2 overflow-hidden">      
          {matchCode?.FILTROS && matchCode.FILTROS.length > 0 && (
            <input
              ref={searchRef}
              type="text"
              placeholder="Texto a Buscar"
              autoFocus={matchCode?.TIPO_PRESENTACIO === "0"}
            />
          )}
        {multiSelect || tipoPresent === "1" ? (
          <div className="flex flex-col gap-2 w-max min-w-full p-0 overflow-hidden">
           <div className="w-max min-w-full max-h-[300px] overflow-hidden">
            <CTSelectTable
              id={`tabla-${matchName}`}
              data={data.map((row) => ({
                ...row,
                check: row.check ?? 0,
              }))}
              columns={visibleFields.map((f) => ({
                header: f.CAPTION,
                accessor: f.NAME,
              }))}
              getRowId={(row) => row[fieldKey]}
              selectedRowId={selectedRowId}
              scrollHorizontal
              pijama={false}
              hoverEffect={true}
              checkField="check" // campo que indica la fila seleccionada
              onSelectionChange={(newData) => {
                setData(newData); // actualiza tu estado
              }}
            />
          </div>
            <CTButton
              iconIndex={16}
              variant="ghost"
              className="w-full justify-center py-3 mt-6 text-base font-semibold"
              bold
              onClick={onDoubleRowTable}
            >
              OK
            </CTButton>
          </div>
        ) : tipoPresent === 2 ? (
          <div className="w-max min-w-full">
            <CTTable
              id={`tabla-${matchName}-tipo2`}
              data={data}
              columns={visibleFields.map((f) => ({
                header: f.CAPTION,
                accessor: f.NAME,
              }))}
              getRowId={(row) => row.ID || row.IDX || row[fieldKey]}
              selectedRowId={selectedRowId}
              onRowClick={onSelectRowTable}
              onRowDoubleClick={onDoubleRowTable}
              scrollHorizontal
              pijama={true}
              hoverEffect={true}
            />
          </div>
        ) : (
          <div className="flex flex-col gap-4 w-max min-w-full p-0 overflow-hidden">
         
           <div className="w-max min-w-full max-h-[300px] overflow-auto">
            <CTTable
              id={`tabla-${matchName}`}
              data={data}
              columns={visibleFields.map((f) => ({
                header: f.CAPTION,
                accessor: f.NAME,
              }))}
              getRowId={(row) => row.ID || row.IDX || row[fieldKey]}
              selectedRowId={selectedRowId}
              onRowClick={onSelectRowTable}
              onRowDoubleClick={onDoubleRowTable}
              scrollHorizontal
              pijama={false}
              hoverEffect={true}
          /> 
          </div>
         
          </div>
        )}
        </div>    
      </div>
    </div>
  );
};

export default CTMatchList;
